// @ts-nocheck
import axios from 'axios';
import { SESSION_TOKEN_ENUM } from '@/constants';
import { reloadPage, clearStorage, prepareAndSendOfflineMessage } from '@/helpers/utils';
import { FileSynchronizationManager } from '@/utils/internalFileStorage/fileSynchronizationManager';
import axiosRetry from 'axios-retry';
import { NUMBER_OF_RETRIES, RETRY_WAIT_MIN_SECS, RETRY_WAIT_MAX_SECS } from '@/config/constants';

axios.interceptors.request.use(function (config) {
  const token = localStorage.getItem(SESSION_TOKEN_ENUM);
  config.headers.Authorization = token;

  return config;
});

axios.interceptors.response.use(
  (response) => {
    return response;
  },
  async (error) => {
    if (401 === error?.response?.status) {
      await prepareAndSendOfflineMessage();
      await clearStorage();
      if (window.isWebOS === true) {
        await FileSynchronizationManager.removeAllInternalFiles();
      } else if (window.isAndroid === true) {
        // @ts-ignore
        // reloadPage first as window.logout has an issue that blocks further execution
        // reloadPage is async so window.logout call to APK will happen regardless
        reloadPage();
        window.logout();
      }

      reloadPage();
    }
    return Promise.reject(error);
  },
);

axiosRetry(axios, {
  retries: NUMBER_OF_RETRIES,
  retryDelay: () => {
    return (
      (Math.floor(Math.random() * (RETRY_WAIT_MAX_SECS - RETRY_WAIT_MIN_SECS + 1)) +
        RETRY_WAIT_MIN_SECS) *
      1000
    );
  },
  retryCondition: (error) => {
    return !!error.response?.status && error.response.status > 500;
  },
});

export default axios;
